
/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

const useUTCtoLocalTime = (utcDateString) => {
  const utcDate = new Date(utcDateString);
  const options = {timeZone: "Asia/Kolkata", hour12: false};
  const istDate = utcDate.toLocaleString("en-IN", options);
  return istDate;
};

export default useUTCtoLocalTime;
